<template>
  <section class="section">
    <h1 class="title">Job Sheets</h1>

    <div
      v-for="(dateSet, index) in jobsByDate"
      v-bind:key="index"
      class="block"
    >
      <div v-if="dateSet.length > 0">
        <h4 class="title is-4">{{ dateSet[0].sdate }}</h4>

        <div
          v-for="(truckSet, index) in jobsBy(dateSet, 'truckName')"
          v-bind:key="index"
        >
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>
                  <h5
                    class="title is-5"
                    v-if="truckSet[0].truckName.length > 0"
                  >
                    {{ truckSet[0].truckName }}
                  </h5>
                  <h5
                    class="title is-5"
                    v-else-if="truckSet[0].truck.length > 0"
                  >
                    {{ truckSet[0].truck }}
                  </h5>
                </th>
                <th>Status</th>
                <th>Load</th>
                <th>Origin</th>
                <th>Destination</th>
                <th>Qty</th>
                <th>Product</th>
                <th>Notes</th>
                <th>Truck</th>
                <th>Driver</th>
              </tr>
            </thead>
            <tbody>
              <JobSheetForm
                v-for="(job, index) in truckSet"
                v-bind:item="job"
                v-bind:index="index"
                v-bind:key="job.id"
                :job="job"
              >
              </JobSheetForm>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import JobSheetForm from "@/components/JobSheetForm";

export default {
  name: "Forms",
  components: { JobSheetForm },
  data() {
    return {
      jobs: [],
      job: null,
      isLoading: false,
      isHidden: false,
      isImageModalActive: false,
      showLoadModal: false,
      isPaginated: true,
      perPage: 10,
      trucks: [],
      // statuses: ["Pending", "Booked", "Delivered", "Complete"],
      statuses: [
        { id: 1, name: "Pending" },
        { id: 2, name: "Booked" },
        { id: 3, name: "In Transit" },
        { id: 4, name: "Delivered" },
        { id: 5, name: "Completed" }
      ]
    };
  },
  computed: {
    jobsByDate: function() {
      return this.jobsBy(this.jobs, "sdate");
    }
  },
  methods: {
    async getJobs() {
      this.jobs = [];
      // Use Axios to make a call to the API
      return axios
        .get(
          this.$store.state.apiUrl +
            "transport?mode=app&row_type=transport_booking&orderby=day",
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        )
        .then(response => {
          var data = response.data;
          var i = 0;
          for (i = 0; i < data.length; i++) {
            // var statusName = "";
            // statusName = this.status.find(x => x.id === data[i].status).name;
            var sdate = "";
            if (data[i].scheduledDate) {
              var scheduledDate = new Date(data[i].scheduledDate);
              const syear = scheduledDate.getFullYear();
              const sday = String(scheduledDate.getDate()).padStart(2, "0");
              const smonth = scheduledDate.getMonth() + 1;
              sdate = sday + "/" + smonth + "/" + syear;
            } else {
              sdate = "Not Scheduled";
            }
            var requestDate = new Date(data[i].requestedPickupTime);
            const year = requestDate.getFullYear();
            const day = String(requestDate.getDate()).padStart(2, "0");
            const month = requestDate.getMonth() + 1;
            const hours = requestDate.getHours();
            const minutes = requestDate.getMinutes();
            var truckName = data[i].truckName;
            for (var key in this.trucks) {
              if (this.trucks[key].name === data[i].truckName) {
                truckName = this.trucks[key].description;
                break;
              }
            }
            var status = "Unknown";
            if (this.statuses[data[i].status] !== undefined) {
              status = this.statuses[data[i].status].name;
            }
            this.jobs.push({
              status: status,
              originAddress:
                data[i].pickupAddress.address +
                " " +
                data[i].pickupAddress.town,
              destAddress:
                data[i].destinationAddress.address +
                " " +
                data[i].pickupAddress.town,
              product: data[i].productName,
              driverNotes: data[i].driverNotes,
              notes: data[i].notes,
              sdate: sdate,
              rdate:
                day + "/" + month + "/" + year + " " + hours + ":" + minutes,
              client:
                data[i].accountCode +
                ":" +
                data[i].clientCode +
                " (" +
                data[i].clientCode +
                ")",
              load: data[i].loadName,
              driver: data[i].driverName,
              truckName: truckName,
              truck: data[i].truckName,
              origin: data[i].pickupAddress.addressName,
              dest: data[i].destinationAddress.addressName,
              qty: data[i].qty,
              price: data[i].priceCharged,
              // status: statusName,
              id: data[i].bookingId
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    jobsBy(jobs, property) {
      var i = 0,
        val,
        index,
        values = [],
        result = [];
      for (; i < jobs.length; i++) {
        val = jobs[i][property];
        index = values.indexOf(val);
        if (index > -1) result[index].push(jobs[i]);
        else {
          values.push(val);
          result.push([jobs[i]]);
        }
      }
      return result;
    },
    onChange() {
      this.isHidden = true;
    },
    selectJob(record) {
      // this.showLoadModal = true
      this.$router.push({ name: "editJob", params: { id: record.id } });
    },
    closeModal() {
      this.showLoadModal = false;
    },
    saveModal() {
      this.showLoadModal = false;
    },
    async getTrucks() {
      this.trucks = null;
      // Use Axios to make a call to the API
      return axios
        .get(this.$store.state.apiUrl + "lookup/vehicle", {
          headers: {
            Authorization: "Bearer " + this.$cookies.get("user_token"),
            "Content-Type": "application/json"
          }
        })
        .then(response => {
          this.trucks = response.data;
          this.getJobs();
        })
        .catch(error => {
          console.log(error);
          this.getJobs();
        });
    }
  },
  mounted() {
    this.getTrucks();
  }
};
</script>
